// Shared aria-label translations for cross-cutting UI chrome.
// Feature-specific content strings (button labels, headings, errors) live in
// per-feature Localize.js files. This file is for the SR/a11y vocabulary that
// isn't tied to any single feature: Close, Search, Pagination controls,
// dropdown-trigger templates, etc.
//
// Templates use `{value}` or `{n}` placeholders — call sites do
// `.replace('{value}', currentValue)` at usage time.
export const Localize = {
    "en_GB": {
        "skip_to_main_content": "Skip to main content",
        "close": "Close",
        "close_search": "Close search",
        "sort_by_currently": "Sort by, currently {value}",
        "filter_sessions_currently": "Filter sessions, currently {value}",
        "filter_by_user_currently": "Filter by user, currently {value}",
        "assignee_currently": "Assignee, currently {value}",
        "host_currently": "Host, currently {value}",
        "selected": "selected",
        "click_to_open_more_information": "Click to open more information",
        "whats_new_panel_open": "What's new panel is open. Press Escape to close it.",
        "whats_new_unread_one": "1 unread notification",
        "whats_new_unread_other": "{value} unread notifications",
        "open_date_picker": "Open date picker",
        "open_time_picker": "Open time picker",
        "previous_month": "Previous month",
        "next_month": "Next month",
        "previous_year": "Previous year",
        "next_year": "Next year",
        "previous_years": "Previous 10 years",
        "next_years": "Next 10 years",
        "hours_label": "Hours",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Start date",
        "start_time_label": "Start time",
        "end_date_label": "End date",
        "end_time_label": "End time",
        "more_session_options": "More session options",
        "more_joining_options": "More joining options",
        "select_images": "Select images",
        "country_currently": "Country, currently {value}",
        "state_currently": "State, currently {value}",
        "search_countries": "Search countries",
        "search_states": "Search states",
        "pagination": "Pagination",
        "first_page": "First page",
        "previous_page": "Previous page",
        "next_page": "Next page",
        "last_page": "Last page",
        "go_to_page": "Go to page {n}",
        "page_current": "Page {n}, current page",
        "rows_per_page_currently": "Rows per page, currently {n}",
        "sorted_ascending": "Sorted by {column}, ascending",
        "sorted_descending": "Sorted by {column}, descending",
        "show_row_details": "Show details",
        "row_details": "Details",
        "hide_row_details": "Hide details",
        "results_found": "{n} results found",
        "results_found_at_least": "At least {n} results found",
        "no_results_found": "No results found",
        "one_result_found": "1 result found",
        "no_sessions_found": "No sessions found",
        "more_results_loaded": "{n} more results loaded",
        "search_cleared": "Search cleared",
        "select_contact_name": "Select {name}",
        "select_contact": "Select contact",
        "select_all_favorites_page": "Select all favorites on this page",
        "select_all_contacts_page": "Select all contacts on this page",
        "invite_contact_name": "Invite {name}",
        "more_actions": "More actions",
        "more_actions_for": "More actions for {name}",
        "clear_search": "Clear search",
        "search_by_currently": "Search by, currently {value}",
        "search_contacts": "Search contacts",
        "clear_selection": "Clear selection",
        "loading": "Loading...",
        "favorite": "Favorite",
        "clear_selected_contact": "Clear selected contact",
        "cancel_editing_contact": "Cancel editing contact",
        "cancel_adding_contact": "Cancel adding contact",
        "copy_label": "Copy {label}",
        "remove_file": "Remove file",
        "import_complete_summary": "Import complete. {imported} imported, {failed} failed of {total}.",
        "no_contacts_found": "No contacts found",
        "n_in_favorites": "{n} in Favorites",
        "no_favorites_found": "No favorite contacts found",
        "one_contact_search_cleared": "Search cleared, showing {n} contact",
        "contacts_search_cleared": "Search cleared, showing {n} contacts",
        "one_favorite_search_cleared": "Search cleared, showing {n} favorite contact",
        "favorites_search_cleared": "Search cleared, showing {n} favorite contacts",
        "one_contact_found": "{n} contact found",
        "contacts_found": "{n} contacts found",
        "one_favorite_found": "{n} favorite contact found",
        "favorites_found": "{n} favorite contacts found",
        "rows_not_imported_region": "{n} rows that could not be imported",
        "save_as_new_contact_available": "Save as New Contact available",
    },
    "de_DE": {
        "skip_to_main_content": "Zum Hauptinhalt springen",
        "close": "Schließen",
        "close_search": "Suche schließen",
        "sort_by_currently": "Sortieren nach, aktuell {value}",
        "filter_sessions_currently": "Sitzungen filtern, aktuell {value}",
        "filter_by_user_currently": "Nach Benutzer filtern, aktuell {value}",
        "assignee_currently": "Zugewiesen, aktuell {value}",
        "host_currently": "Host, aktuell {value}",
        "selected": "ausgewählt",
        "click_to_open_more_information": "Klicken Sie hier, um weitere Informationen zu öffnen",
        "whats_new_panel_open": "Das Fenster „Neuigkeiten“ ist geöffnet. Drücken Sie Escape, um es zu schließen.",
        "whats_new_unread_one": "1 ungelesene Benachrichtigung",
        "whats_new_unread_other": "{value} ungelesene Benachrichtigungen",
        "open_date_picker": "Datumsauswahl öffnen",
        "open_time_picker": "Zeitauswahl öffnen",
        "previous_month": "Vorheriger Monat",
        "next_month": "Nächster Monat",
        "previous_year": "Vorheriges Jahr",
        "next_year": "Nächstes Jahr",
        "previous_years": "Vorherige 10 Jahre",
        "next_years": "Nächste 10 Jahre",
        "hours_label": "Stunden",
        "minutes_label": "Minuten",
        "am_pm_label": "AM/PM",
        "start_date_label": "Startdatum",
        "start_time_label": "Startzeit",
        "end_date_label": "Enddatum",
        "end_time_label": "Endzeit",
        "more_session_options": "Weitere Sitzungsoptionen",
        "more_joining_options": "Weitere Beitrittsoptionen",
        "select_images": "Bilder auswählen",
        "country_currently": "Land, aktuell {value}",
        "state_currently": "Bundesland, aktuell {value}",
        "search_countries": "Länder suchen",
        "search_states": "Bundesländer suchen",
        "pagination": "Paginierung",
        "first_page": "Erste Seite",
        "previous_page": "Vorherige Seite",
        "next_page": "Nächste Seite",
        "last_page": "Letzte Seite",
        "go_to_page": "Zu Seite {n} gehen",
        "page_current": "Seite {n}, aktuelle Seite",
        "rows_per_page_currently": "Zeilen pro Seite, aktuell {n}",
        "sorted_ascending": "Sortiert nach {column}, aufsteigend",
        "sorted_descending": "Sortiert nach {column}, absteigend",
        "show_row_details": "Details anzeigen",
        "row_details": "Details",
        "hide_row_details": "Details ausblenden",
        "results_found": "{n} Ergebnisse gefunden",
        "results_found_at_least": "Mindestens {n} Ergebnisse gefunden",
        "no_results_found": "Keine Ergebnisse gefunden",
        "one_result_found": "1 Ergebnis gefunden",
        "no_sessions_found": "Keine Sitzungen gefunden",
        "more_results_loaded": "{n} weitere Ergebnisse geladen",
        "search_cleared": "Suche gelöscht",
        "select_contact_name": "{name} auswählen",
        "select_contact": "Kontakt auswählen",
        "select_all_favorites_page": "Alle Favoriten auf dieser Seite auswählen",
        "select_all_contacts_page": "Alle Kontakte auf dieser Seite auswählen",
        "invite_contact_name": "{name} einladen",
        "more_actions": "Weitere Aktionen",
        "more_actions_for": "Weitere Aktionen für {name}",
        "clear_search": "Suche löschen",
        "search_by_currently": "Suchen nach, aktuell {value}",
        "search_contacts": "Kontakte suchen",
        "clear_selection": "Auswahl aufheben",
        "loading": "Wird geladen...",
        "favorite": "Favorit",
        "clear_selected_contact": "Ausgewählten Kontakt entfernen",
        "cancel_editing_contact": "Bearbeiten des Kontakts abbrechen",
        "cancel_adding_contact": "Hinzufügen des Kontakts abbrechen",
        "copy_label": "{label} kopieren",
        "remove_file": "Datei entfernen",
        "import_complete_summary": "Import abgeschlossen. {imported} importiert, {failed} fehlgeschlagen von {total}.",
        "no_contacts_found": "Keine Kontakte gefunden",
        "n_in_favorites": "{n} in Favoriten",
        "no_favorites_found": "Keine Favoriten gefunden",
        "one_contact_search_cleared": "Suche gelöscht, {n} Kontakt wird angezeigt",
        "contacts_search_cleared": "Suche gelöscht, {n} Kontakte werden angezeigt",
        "one_favorite_search_cleared": "Suche gelöscht, {n} Favorit wird angezeigt",
        "favorites_search_cleared": "Suche gelöscht, {n} Favoriten werden angezeigt",
        "one_contact_found": "{n} Kontakt gefunden",
        "contacts_found": "{n} Kontakte gefunden",
        "one_favorite_found": "{n} Favorit gefunden",
        "favorites_found": "{n} Favoriten gefunden",
        "rows_not_imported_region": "Nicht importierte Zeilen: {n}",
        "save_as_new_contact_available": "Als neuen Kontakt speichern ist verfügbar",
    },
    "en_US": {
        "skip_to_main_content": "Skip to main content",
        "close": "Close",
        "close_search": "Close search",
        "sort_by_currently": "Sort by, currently {value}",
        "filter_sessions_currently": "Filter sessions, currently {value}",
        "filter_by_user_currently": "Filter by user, currently {value}",
        "assignee_currently": "Assignee, currently {value}",
        "host_currently": "Host, currently {value}",
        "selected": "selected",
        "click_to_open_more_information": "Click to open more information",
        "whats_new_panel_open": "What's new panel is open. Press Escape to close it.",
        "whats_new_unread_one": "1 unread notification",
        "whats_new_unread_other": "{value} unread notifications",
        "open_date_picker": "Open date picker",
        "open_time_picker": "Open time picker",
        "previous_month": "Previous month",
        "next_month": "Next month",
        "previous_year": "Previous year",
        "next_year": "Next year",
        "previous_years": "Previous 10 years",
        "next_years": "Next 10 years",
        "hours_label": "Hours",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Start date",
        "start_time_label": "Start time",
        "end_date_label": "End date",
        "end_time_label": "End time",
        "more_session_options": "More session options",
        "more_joining_options": "More joining options",
        "select_images": "Select images",
        "country_currently": "Country, currently {value}",
        "state_currently": "State, currently {value}",
        "search_countries": "Search countries",
        "search_states": "Search states",
        "pagination": "Pagination",
        "first_page": "First page",
        "previous_page": "Previous page",
        "next_page": "Next page",
        "last_page": "Last page",
        "go_to_page": "Go to page {n}",
        "page_current": "Page {n}, current page",
        "rows_per_page_currently": "Rows per page, currently {n}",
        "sorted_ascending": "Sorted by {column}, ascending",
        "sorted_descending": "Sorted by {column}, descending",
        "show_row_details": "Show details",
        "row_details": "Details",
        "hide_row_details": "Hide details",
        "results_found": "{n} results found",
        "results_found_at_least": "At least {n} results found",
        "no_results_found": "No results found",
        "one_result_found": "1 result found",
        "no_sessions_found": "No sessions found",
        "more_results_loaded": "{n} more results loaded",
        "search_cleared": "Search cleared",
        "select_contact_name": "Select {name}",
        "select_contact": "Select contact",
        "select_all_favorites_page": "Select all favorites on this page",
        "select_all_contacts_page": "Select all contacts on this page",
        "invite_contact_name": "Invite {name}",
        "more_actions": "More actions",
        "more_actions_for": "More actions for {name}",
        "clear_search": "Clear search",
        "search_by_currently": "Search by, currently {value}",
        "search_contacts": "Search contacts",
        "clear_selection": "Clear selection",
        "loading": "Loading...",
        "favorite": "Favorite",
        "clear_selected_contact": "Clear selected contact",
        "cancel_editing_contact": "Cancel editing contact",
        "cancel_adding_contact": "Cancel adding contact",
        "copy_label": "Copy {label}",
        "remove_file": "Remove file",
        "import_complete_summary": "Import complete. {imported} imported, {failed} failed of {total}.",
        "no_contacts_found": "No contacts found",
        "n_in_favorites": "{n} in Favorites",
        "no_favorites_found": "No favorite contacts found",
        "one_contact_search_cleared": "Search cleared, showing {n} contact",
        "contacts_search_cleared": "Search cleared, showing {n} contacts",
        "one_favorite_search_cleared": "Search cleared, showing {n} favorite contact",
        "favorites_search_cleared": "Search cleared, showing {n} favorite contacts",
        "one_contact_found": "{n} contact found",
        "contacts_found": "{n} contacts found",
        "one_favorite_found": "{n} favorite contact found",
        "favorites_found": "{n} favorite contacts found",
        "rows_not_imported_region": "{n} rows that could not be imported",
        "save_as_new_contact_available": "Save as New Contact available",
    },
    "en_AU": {
        "skip_to_main_content": "Skip to main content",
        "close": "Close",
        "close_search": "Close search",
        "sort_by_currently": "Sort by, currently {value}",
        "filter_sessions_currently": "Filter sessions, currently {value}",
        "filter_by_user_currently": "Filter by user, currently {value}",
        "assignee_currently": "Assignee, currently {value}",
        "host_currently": "Host, currently {value}",
        "selected": "selected",
        "click_to_open_more_information": "Click to open more information",
        "whats_new_panel_open": "What's new panel is open. Press Escape to close it.",
        "whats_new_unread_one": "1 unread notification",
        "whats_new_unread_other": "{value} unread notifications",
        "open_date_picker": "Open date picker",
        "open_time_picker": "Open time picker",
        "previous_month": "Previous month",
        "next_month": "Next month",
        "previous_year": "Previous year",
        "next_year": "Next year",
        "previous_years": "Previous 10 years",
        "next_years": "Next 10 years",
        "hours_label": "Hours",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Start date",
        "start_time_label": "Start time",
        "end_date_label": "End date",
        "end_time_label": "End time",
        "more_session_options": "More session options",
        "more_joining_options": "More joining options",
        "select_images": "Select images",
        "country_currently": "Country, currently {value}",
        "state_currently": "State, currently {value}",
        "search_countries": "Search countries",
        "search_states": "Search states",
        "pagination": "Pagination",
        "first_page": "First page",
        "previous_page": "Previous page",
        "next_page": "Next page",
        "last_page": "Last page",
        "go_to_page": "Go to page {n}",
        "page_current": "Page {n}, current page",
        "rows_per_page_currently": "Rows per page, currently {n}",
        "sorted_ascending": "Sorted by {column}, ascending",
        "sorted_descending": "Sorted by {column}, descending",
        "show_row_details": "Show details",
        "row_details": "Details",
        "hide_row_details": "Hide details",
        "results_found": "{n} results found",
        "results_found_at_least": "At least {n} results found",
        "no_results_found": "No results found",
        "one_result_found": "1 result found",
        "no_sessions_found": "No sessions found",
        "more_results_loaded": "{n} more results loaded",
        "search_cleared": "Search cleared",
        "select_contact_name": "Select {name}",
        "select_contact": "Select contact",
        "select_all_favorites_page": "Select all favorites on this page",
        "select_all_contacts_page": "Select all contacts on this page",
        "invite_contact_name": "Invite {name}",
        "more_actions": "More actions",
        "more_actions_for": "More actions for {name}",
        "clear_search": "Clear search",
        "search_by_currently": "Search by, currently {value}",
        "search_contacts": "Search contacts",
        "clear_selection": "Clear selection",
        "loading": "Loading...",
        "favorite": "Favorite",
        "clear_selected_contact": "Clear selected contact",
        "cancel_editing_contact": "Cancel editing contact",
        "cancel_adding_contact": "Cancel adding contact",
        "copy_label": "Copy {label}",
        "remove_file": "Remove file",
        "import_complete_summary": "Import complete. {imported} imported, {failed} failed of {total}.",
        "no_contacts_found": "No contacts found",
        "n_in_favorites": "{n} in Favorites",
        "no_favorites_found": "No favorite contacts found",
        "one_contact_search_cleared": "Search cleared, showing {n} contact",
        "contacts_search_cleared": "Search cleared, showing {n} contacts",
        "one_favorite_search_cleared": "Search cleared, showing {n} favorite contact",
        "favorites_search_cleared": "Search cleared, showing {n} favorite contacts",
        "one_contact_found": "{n} contact found",
        "contacts_found": "{n} contacts found",
        "one_favorite_found": "{n} favorite contact found",
        "favorites_found": "{n} favorite contacts found",
        "rows_not_imported_region": "{n} rows that could not be imported",
        "save_as_new_contact_available": "Save as New Contact available",
    },
    "es_ES": {
        "skip_to_main_content": "Saltar al contenido principal",
        "close": "Cerrar",
        "close_search": "Cerrar búsqueda",
        "sort_by_currently": "Ordenar por, actualmente {value}",
        "filter_sessions_currently": "Filtrar sesiones, actualmente {value}",
        "filter_by_user_currently": "Filtrar por usuario, actualmente {value}",
        "assignee_currently": "Asignado, actualmente {value}",
        "host_currently": "Anfitrión, actualmente {value}",
        "selected": "seleccionado",
        "click_to_open_more_information": "Haga clic para abrir más información",
        "whats_new_panel_open": "El panel de novedades está abierto. Pulse Escape para cerrarlo.",
        "whats_new_unread_one": "1 notificación sin leer",
        "whats_new_unread_other": "{value} notificaciones sin leer",
        "open_date_picker": "Abrir selector de fecha",
        "open_time_picker": "Abrir selector de hora",
        "previous_month": "Mes anterior",
        "next_month": "Mes siguiente",
        "previous_year": "Año anterior",
        "next_year": "Año siguiente",
        "previous_years": "10 años anteriores",
        "next_years": "10 años siguientes",
        "hours_label": "Horas",
        "minutes_label": "Minutos",
        "am_pm_label": "AM/PM",
        "start_date_label": "Fecha de inicio",
        "start_time_label": "Hora de inicio",
        "end_date_label": "Fecha de finalización",
        "end_time_label": "Hora de finalización",
        "more_session_options": "Más opciones de sesión",
        "more_joining_options": "Más opciones para unirse",
        "select_images": "Seleccionar imágenes",
        "country_currently": "País, actualmente {value}",
        "state_currently": "Estado, actualmente {value}",
        "search_countries": "Buscar países",
        "search_states": "Buscar estados",
        "pagination": "Paginación",
        "first_page": "Primera página",
        "previous_page": "Página anterior",
        "next_page": "Página siguiente",
        "last_page": "Última página",
        "go_to_page": "Ir a la página {n}",
        "page_current": "Página {n}, página actual",
        "rows_per_page_currently": "Filas por página, actualmente {n}",
        "sorted_ascending": "Ordenado por {column}, ascendente",
        "sorted_descending": "Ordenado por {column}, descendente",
        "show_row_details": "Mostrar detalles",
        "row_details": "Detalles",
        "hide_row_details": "Ocultar detalles",
        "results_found": "{n} resultados encontrados",
        "results_found_at_least": "Al menos {n} resultados encontrados",
        "no_results_found": "No se encontraron resultados",
        "one_result_found": "1 resultado encontrado",
        "no_sessions_found": "No se encontraron sesiones",
        "more_results_loaded": "{n} resultados más cargados",
        "search_cleared": "Búsqueda borrada",
        "select_contact_name": "Seleccionar a {name}",
        "select_contact": "Seleccionar contacto",
        "select_all_favorites_page": "Seleccionar todos los favoritos de esta página",
        "select_all_contacts_page": "Seleccionar todos los contactos de esta página",
        "invite_contact_name": "Invitar a {name}",
        "more_actions": "Más acciones",
        "more_actions_for": "Más acciones para {name}",
        "clear_search": "Borrar búsqueda",
        "search_by_currently": "Buscar por, actualmente {value}",
        "search_contacts": "Buscar contactos",
        "clear_selection": "Borrar selección",
        "loading": "Cargando...",
        "favorite": "Favorito",
        "clear_selected_contact": "Quitar contacto seleccionado",
        "cancel_editing_contact": "Cancelar la edición del contacto",
        "cancel_adding_contact": "Cancelar la adición del contacto",
        "copy_label": "Copiar {label}",
        "remove_file": "Quitar archivo",
        "import_complete_summary": "Importación completa. {imported} importados, {failed} fallidos de {total}.",
        "no_contacts_found": "No se encontraron contactos",
        "n_in_favorites": "{n} en favoritos",
        "no_favorites_found": "No se encontraron contactos favoritos",
        "one_contact_search_cleared": "Búsqueda borrada, se muestra {n} contacto",
        "contacts_search_cleared": "Búsqueda borrada, se muestran {n} contactos",
        "one_favorite_search_cleared": "Búsqueda borrada, se muestra {n} contacto favorito",
        "favorites_search_cleared": "Búsqueda borrada, se muestran {n} contactos favoritos",
        "one_contact_found": "{n} contacto encontrado",
        "contacts_found": "{n} contactos encontrados",
        "one_favorite_found": "{n} contacto favorito encontrado",
        "favorites_found": "{n} contactos favoritos encontrados",
        "rows_not_imported_region": "Filas que no se pudieron importar: {n}",
        "save_as_new_contact_available": "Guardar como nuevo contacto disponible",
    },
    "es_MX": {
        "skip_to_main_content": "Saltar al contenido principal",
        "close": "Cerrar",
        "close_search": "Cerrar búsqueda",
        "sort_by_currently": "Ordenar por, actualmente {value}",
        "filter_sessions_currently": "Filtrar sesiones, actualmente {value}",
        "filter_by_user_currently": "Filtrar por usuario, actualmente {value}",
        "assignee_currently": "Asignado, actualmente {value}",
        "host_currently": "Anfitrión, actualmente {value}",
        "selected": "seleccionado",
        "click_to_open_more_information": "Haga clic para abrir más información",
        "whats_new_panel_open": "El panel de novedades está abierto. Pulse Escape para cerrarlo.",
        "whats_new_unread_one": "1 notificación sin leer",
        "whats_new_unread_other": "{value} notificaciones sin leer",
        "open_date_picker": "Abrir selector de fecha",
        "open_time_picker": "Abrir selector de hora",
        "previous_month": "Mes anterior",
        "next_month": "Mes siguiente",
        "previous_year": "Año anterior",
        "next_year": "Año siguiente",
        "previous_years": "10 años anteriores",
        "next_years": "10 años siguientes",
        "hours_label": "Horas",
        "minutes_label": "Minutos",
        "am_pm_label": "AM/PM",
        "start_date_label": "Fecha de inicio",
        "start_time_label": "Hora de inicio",
        "end_date_label": "Fecha de finalización",
        "end_time_label": "Hora de finalización",
        "more_session_options": "Más opciones de sesión",
        "more_joining_options": "Más opciones para unirse",
        "select_images": "Seleccionar imágenes",
        "country_currently": "País, actualmente {value}",
        "state_currently": "Estado, actualmente {value}",
        "search_countries": "Buscar países",
        "search_states": "Buscar estados",
        "pagination": "Paginación",
        "first_page": "Primera página",
        "previous_page": "Página anterior",
        "next_page": "Página siguiente",
        "last_page": "Última página",
        "go_to_page": "Ir a la página {n}",
        "page_current": "Página {n}, página actual",
        "rows_per_page_currently": "Filas por página, actualmente {n}",
        "sorted_ascending": "Ordenado por {column}, ascendente",
        "sorted_descending": "Ordenado por {column}, descendente",
        "show_row_details": "Mostrar detalles",
        "row_details": "Detalles",
        "hide_row_details": "Ocultar detalles",
        "results_found": "{n} resultados encontrados",
        "results_found_at_least": "Al menos {n} resultados encontrados",
        "no_results_found": "No se encontraron resultados",
        "one_result_found": "1 resultado encontrado",
        "no_sessions_found": "No se encontraron sesiones",
        "more_results_loaded": "{n} resultados más cargados",
        "search_cleared": "Búsqueda borrada",
        "select_contact_name": "Seleccionar a {name}",
        "select_contact": "Seleccionar contacto",
        "select_all_favorites_page": "Seleccionar todos los favoritos de esta página",
        "select_all_contacts_page": "Seleccionar todos los contactos de esta página",
        "invite_contact_name": "Invitar a {name}",
        "more_actions": "Más acciones",
        "more_actions_for": "Más acciones para {name}",
        "clear_search": "Borrar búsqueda",
        "search_by_currently": "Buscar por, actualmente {value}",
        "search_contacts": "Buscar contactos",
        "clear_selection": "Borrar selección",
        "loading": "Cargando...",
        "favorite": "Favorito",
        "clear_selected_contact": "Quitar contacto seleccionado",
        "cancel_editing_contact": "Cancelar la edición del contacto",
        "cancel_adding_contact": "Cancelar la adición del contacto",
        "copy_label": "Copiar {label}",
        "remove_file": "Quitar archivo",
        "import_complete_summary": "Importación completa. {imported} importados, {failed} fallidos de {total}.",
        "no_contacts_found": "No se encontraron contactos",
        "n_in_favorites": "{n} en favoritos",
        "no_favorites_found": "No se encontraron contactos favoritos",
        "one_contact_search_cleared": "Búsqueda borrada, se muestra {n} contacto",
        "contacts_search_cleared": "Búsqueda borrada, se muestran {n} contactos",
        "one_favorite_search_cleared": "Búsqueda borrada, se muestra {n} contacto favorito",
        "favorites_search_cleared": "Búsqueda borrada, se muestran {n} contactos favoritos",
        "one_contact_found": "{n} contacto encontrado",
        "contacts_found": "{n} contactos encontrados",
        "one_favorite_found": "{n} contacto favorito encontrado",
        "favorites_found": "{n} contactos favoritos encontrados",
        "rows_not_imported_region": "Filas que no se pudieron importar: {n}",
        "save_as_new_contact_available": "Guardar como nuevo contacto disponible",
    },
    "es_AR": {
        "skip_to_main_content": "Saltar al contenido principal",
        "close": "Cerrar",
        "close_search": "Cerrar búsqueda",
        "sort_by_currently": "Ordenar por, actualmente {value}",
        "filter_sessions_currently": "Filtrar sesiones, actualmente {value}",
        "filter_by_user_currently": "Filtrar por usuario, actualmente {value}",
        "assignee_currently": "Asignado, actualmente {value}",
        "host_currently": "Anfitrión, actualmente {value}",
        "selected": "seleccionado",
        "click_to_open_more_information": "Haga clic para abrir más información",
        "whats_new_panel_open": "El panel de novedades está abierto. Pulse Escape para cerrarlo.",
        "whats_new_unread_one": "1 notificación sin leer",
        "whats_new_unread_other": "{value} notificaciones sin leer",
        "open_date_picker": "Abrir selector de fecha",
        "open_time_picker": "Abrir selector de hora",
        "previous_month": "Mes anterior",
        "next_month": "Mes siguiente",
        "previous_year": "Año anterior",
        "next_year": "Año siguiente",
        "previous_years": "10 años anteriores",
        "next_years": "10 años siguientes",
        "hours_label": "Horas",
        "minutes_label": "Minutos",
        "am_pm_label": "AM/PM",
        "start_date_label": "Fecha de inicio",
        "start_time_label": "Hora de inicio",
        "end_date_label": "Fecha de finalización",
        "end_time_label": "Hora de finalización",
        "more_session_options": "Más opciones de sesión",
        "more_joining_options": "Más opciones para unirse",
        "select_images": "Seleccionar imágenes",
        "country_currently": "País, actualmente {value}",
        "state_currently": "Estado, actualmente {value}",
        "search_countries": "Buscar países",
        "search_states": "Buscar estados",
        "pagination": "Paginación",
        "first_page": "Primera página",
        "previous_page": "Página anterior",
        "next_page": "Página siguiente",
        "last_page": "Última página",
        "go_to_page": "Ir a la página {n}",
        "page_current": "Página {n}, página actual",
        "rows_per_page_currently": "Filas por página, actualmente {n}",
        "sorted_ascending": "Ordenado por {column}, ascendente",
        "sorted_descending": "Ordenado por {column}, descendente",
        "show_row_details": "Mostrar detalles",
        "row_details": "Detalles",
        "hide_row_details": "Ocultar detalles",
        "results_found": "{n} resultados encontrados",
        "results_found_at_least": "Al menos {n} resultados encontrados",
        "no_results_found": "No se encontraron resultados",
        "one_result_found": "1 resultado encontrado",
        "no_sessions_found": "No se encontraron sesiones",
        "more_results_loaded": "{n} resultados más cargados",
        "search_cleared": "Búsqueda borrada",
        "select_contact_name": "Seleccionar a {name}",
        "select_contact": "Seleccionar contacto",
        "select_all_favorites_page": "Seleccionar todos los favoritos de esta página",
        "select_all_contacts_page": "Seleccionar todos los contactos de esta página",
        "invite_contact_name": "Invitar a {name}",
        "more_actions": "Más acciones",
        "more_actions_for": "Más acciones para {name}",
        "clear_search": "Borrar búsqueda",
        "search_by_currently": "Buscar por, actualmente {value}",
        "search_contacts": "Buscar contactos",
        "clear_selection": "Borrar selección",
        "loading": "Cargando...",
        "favorite": "Favorito",
        "clear_selected_contact": "Quitar contacto seleccionado",
        "cancel_editing_contact": "Cancelar la edición del contacto",
        "cancel_adding_contact": "Cancelar la adición del contacto",
        "copy_label": "Copiar {label}",
        "remove_file": "Quitar archivo",
        "import_complete_summary": "Importación completa. {imported} importados, {failed} fallidos de {total}.",
        "no_contacts_found": "No se encontraron contactos",
        "n_in_favorites": "{n} en favoritos",
        "no_favorites_found": "No se encontraron contactos favoritos",
        "one_contact_search_cleared": "Búsqueda borrada, se muestra {n} contacto",
        "contacts_search_cleared": "Búsqueda borrada, se muestran {n} contactos",
        "one_favorite_search_cleared": "Búsqueda borrada, se muestra {n} contacto favorito",
        "favorites_search_cleared": "Búsqueda borrada, se muestran {n} contactos favoritos",
        "one_contact_found": "{n} contacto encontrado",
        "contacts_found": "{n} contactos encontrados",
        "one_favorite_found": "{n} contacto favorito encontrado",
        "favorites_found": "{n} contactos favoritos encontrados",
        "rows_not_imported_region": "Filas que no se pudieron importar: {n}",
        "save_as_new_contact_available": "Guardar como nuevo contacto disponible",
    },
    "fr_FR": {
        "skip_to_main_content": "Aller au contenu principal",
        "close": "Fermer",
        "close_search": "Fermer la recherche",
        "sort_by_currently": "Trier par, actuellement {value}",
        "filter_sessions_currently": "Filtrer les sessions, actuellement {value}",
        "filter_by_user_currently": "Filtrer par utilisateur, actuellement {value}",
        "assignee_currently": "Attribué, actuellement {value}",
        "host_currently": "Hôte, actuellement {value}",
        "selected": "sélectionné",
        "click_to_open_more_information": "Cliquez pour ouvrir plus d'informations",
        "whats_new_panel_open": "Le panneau des nouveautés est ouvert. Appuyez sur Échap pour le fermer.",
        "whats_new_unread_one": "1 notification non lue",
        "whats_new_unread_other": "{value} notifications non lues",
        "open_date_picker": "Ouvrir le sélecteur de date",
        "open_time_picker": "Ouvrir le sélecteur d'heure",
        "previous_month": "Mois précédent",
        "next_month": "Mois suivant",
        "previous_year": "Année précédente",
        "next_year": "Année suivante",
        "previous_years": "10 années précédentes",
        "next_years": "10 années suivantes",
        "hours_label": "Heures",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Date de début",
        "start_time_label": "Heure de début",
        "end_date_label": "Date de fin",
        "end_time_label": "Heure de fin",
        "more_session_options": "Plus d'options de session",
        "more_joining_options": "Plus d'options pour rejoindre",
        "select_images": "Sélectionner des images",
        "country_currently": "Pays, actuellement {value}",
        "state_currently": "État, actuellement {value}",
        "search_countries": "Rechercher des pays",
        "search_states": "Rechercher des états",
        "pagination": "Pagination",
        "first_page": "Première page",
        "previous_page": "Page précédente",
        "next_page": "Page suivante",
        "last_page": "Dernière page",
        "go_to_page": "Aller à la page {n}",
        "page_current": "Page {n}, page actuelle",
        "rows_per_page_currently": "Lignes par page, actuellement {n}",
        "sorted_ascending": "Trié par {column}, croissant",
        "sorted_descending": "Trié par {column}, décroissant",
        "show_row_details": "Afficher les détails",
        "row_details": "Détails",
        "hide_row_details": "Masquer les détails",
        "results_found": "{n} résultats trouvés",
        "results_found_at_least": "Au moins {n} résultats trouvés",
        "no_results_found": "Aucun résultat trouvé",
        "one_result_found": "1 résultat trouvé",
        "no_sessions_found": "Aucune session trouvée",
        "more_results_loaded": "{n} résultats supplémentaires chargés",
        "search_cleared": "Recherche effacée",
        "select_contact_name": "Sélectionner {name}",
        "select_contact": "Sélectionner le contact",
        "select_all_favorites_page": "Sélectionner tous les favoris de cette page",
        "select_all_contacts_page": "Sélectionner tous les contacts de cette page",
        "invite_contact_name": "Inviter {name}",
        "more_actions": "Plus d'actions",
        "more_actions_for": "Plus d'actions pour {name}",
        "clear_search": "Effacer la recherche",
        "search_by_currently": "Rechercher par, actuellement {value}",
        "search_contacts": "Rechercher des contacts",
        "clear_selection": "Effacer la sélection",
        "loading": "Chargement...",
        "favorite": "Favori",
        "clear_selected_contact": "Retirer le contact sélectionné",
        "cancel_editing_contact": "Annuler la modification du contact",
        "cancel_adding_contact": "Annuler l'ajout du contact",
        "copy_label": "Copier {label}",
        "remove_file": "Retirer le fichier",
        "import_complete_summary": "Importation terminée. {imported} importés, {failed} en échec sur {total}.",
        "no_contacts_found": "Aucun contact trouvé",
        "n_in_favorites": "{n} dans les favoris",
        "no_favorites_found": "Aucun contact favori trouvé",
        "one_contact_search_cleared": "Recherche effacée, {n} contact affiché",
        "contacts_search_cleared": "Recherche effacée, {n} contacts affichés",
        "one_favorite_search_cleared": "Recherche effacée, {n} contact favori affiché",
        "favorites_search_cleared": "Recherche effacée, {n} contacts favoris affichés",
        "one_contact_found": "{n} contact trouvé",
        "contacts_found": "{n} contacts trouvés",
        "one_favorite_found": "{n} contact favori trouvé",
        "favorites_found": "{n} contacts favoris trouvés",
        "rows_not_imported_region": "Lignes non importées : {n}",
        "save_as_new_contact_available": "Enregistrer comme nouveau contact disponible",
    },
    "en_CA": {
        "skip_to_main_content": "Skip to main content",
        "close": "Close",
        "close_search": "Close search",
        "sort_by_currently": "Sort by, currently {value}",
        "filter_sessions_currently": "Filter sessions, currently {value}",
        "filter_by_user_currently": "Filter by user, currently {value}",
        "assignee_currently": "Assignee, currently {value}",
        "host_currently": "Host, currently {value}",
        "selected": "selected",
        "click_to_open_more_information": "Click to open more information",
        "whats_new_panel_open": "What's new panel is open. Press Escape to close it.",
        "whats_new_unread_one": "1 unread notification",
        "whats_new_unread_other": "{value} unread notifications",
        "open_date_picker": "Open date picker",
        "open_time_picker": "Open time picker",
        "previous_month": "Previous month",
        "next_month": "Next month",
        "previous_year": "Previous year",
        "next_year": "Next year",
        "previous_years": "Previous 10 years",
        "next_years": "Next 10 years",
        "hours_label": "Hours",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Start date",
        "start_time_label": "Start time",
        "end_date_label": "End date",
        "end_time_label": "End time",
        "more_session_options": "More session options",
        "more_joining_options": "More joining options",
        "select_images": "Select images",
        "country_currently": "Country, currently {value}",
        "state_currently": "State, currently {value}",
        "search_countries": "Search countries",
        "search_states": "Search states",
        "pagination": "Pagination",
        "first_page": "First page",
        "previous_page": "Previous page",
        "next_page": "Next page",
        "last_page": "Last page",
        "go_to_page": "Go to page {n}",
        "page_current": "Page {n}, current page",
        "rows_per_page_currently": "Rows per page, currently {n}",
        "sorted_ascending": "Sorted by {column}, ascending",
        "sorted_descending": "Sorted by {column}, descending",
        "show_row_details": "Show details",
        "row_details": "Details",
        "hide_row_details": "Hide details",
        "results_found": "{n} results found",
        "results_found_at_least": "At least {n} results found",
        "no_results_found": "No results found",
        "one_result_found": "1 result found",
        "no_sessions_found": "No sessions found",
        "more_results_loaded": "{n} more results loaded",
        "search_cleared": "Search cleared",
        "select_contact_name": "Select {name}",
        "select_contact": "Select contact",
        "select_all_favorites_page": "Select all favorites on this page",
        "select_all_contacts_page": "Select all contacts on this page",
        "invite_contact_name": "Invite {name}",
        "more_actions": "More actions",
        "more_actions_for": "More actions for {name}",
        "clear_search": "Clear search",
        "search_by_currently": "Search by, currently {value}",
        "search_contacts": "Search contacts",
        "clear_selection": "Clear selection",
        "loading": "Loading...",
        "favorite": "Favorite",
        "clear_selected_contact": "Clear selected contact",
        "cancel_editing_contact": "Cancel editing contact",
        "cancel_adding_contact": "Cancel adding contact",
        "copy_label": "Copy {label}",
        "remove_file": "Remove file",
        "import_complete_summary": "Import complete. {imported} imported, {failed} failed of {total}.",
        "no_contacts_found": "No contacts found",
        "n_in_favorites": "{n} in Favorites",
        "no_favorites_found": "No favorite contacts found",
        "one_contact_search_cleared": "Search cleared, showing {n} contact",
        "contacts_search_cleared": "Search cleared, showing {n} contacts",
        "one_favorite_search_cleared": "Search cleared, showing {n} favorite contact",
        "favorites_search_cleared": "Search cleared, showing {n} favorite contacts",
        "one_contact_found": "{n} contact found",
        "contacts_found": "{n} contacts found",
        "one_favorite_found": "{n} favorite contact found",
        "favorites_found": "{n} favorite contacts found",
        "rows_not_imported_region": "{n} rows that could not be imported",
        "save_as_new_contact_available": "Save as New Contact available",
    },
    "fr_CA": {
        "skip_to_main_content": "Aller au contenu principal",
        "close": "Fermer",
        "close_search": "Fermer la recherche",
        "sort_by_currently": "Trier par, actuellement {value}",
        "filter_sessions_currently": "Filtrer les sessions, actuellement {value}",
        "filter_by_user_currently": "Filtrer par utilisateur, actuellement {value}",
        "assignee_currently": "Attribué, actuellement {value}",
        "host_currently": "Hôte, actuellement {value}",
        "selected": "sélectionné",
        "click_to_open_more_information": "Cliquez pour ouvrir plus d'informations",
        "whats_new_panel_open": "Le panneau des nouveautés est ouvert. Appuyez sur Échap pour le fermer.",
        "whats_new_unread_one": "1 notification non lue",
        "whats_new_unread_other": "{value} notifications non lues",
        "open_date_picker": "Ouvrir le sélecteur de date",
        "open_time_picker": "Ouvrir le sélecteur d'heure",
        "previous_month": "Mois précédent",
        "next_month": "Mois suivant",
        "previous_year": "Année précédente",
        "next_year": "Année suivante",
        "previous_years": "10 années précédentes",
        "next_years": "10 années suivantes",
        "hours_label": "Heures",
        "minutes_label": "Minutes",
        "am_pm_label": "AM/PM",
        "start_date_label": "Date de début",
        "start_time_label": "Heure de début",
        "end_date_label": "Date de fin",
        "end_time_label": "Heure de fin",
        "more_session_options": "Plus d'options de session",
        "more_joining_options": "Plus d'options pour rejoindre",
        "select_images": "Sélectionner des images",
        "country_currently": "Pays, actuellement {value}",
        "state_currently": "État, actuellement {value}",
        "search_countries": "Rechercher des pays",
        "search_states": "Rechercher des états",
        "pagination": "Pagination",
        "first_page": "Première page",
        "previous_page": "Page précédente",
        "next_page": "Page suivante",
        "last_page": "Dernière page",
        "go_to_page": "Aller à la page {n}",
        "page_current": "Page {n}, page actuelle",
        "rows_per_page_currently": "Lignes par page, actuellement {n}",
        "sorted_ascending": "Trié par {column}, croissant",
        "sorted_descending": "Trié par {column}, décroissant",
        "show_row_details": "Afficher les détails",
        "row_details": "Détails",
        "hide_row_details": "Masquer les détails",
        "results_found": "{n} résultats trouvés",
        "results_found_at_least": "Au moins {n} résultats trouvés",
        "no_results_found": "Aucun résultat trouvé",
        "one_result_found": "1 résultat trouvé",
        "no_sessions_found": "Aucune session trouvée",
        "more_results_loaded": "{n} résultats supplémentaires chargés",
        "search_cleared": "Recherche effacée",
        "select_contact_name": "Sélectionner {name}",
        "select_contact": "Sélectionner le contact",
        "select_all_favorites_page": "Sélectionner tous les favoris de cette page",
        "select_all_contacts_page": "Sélectionner tous les contacts de cette page",
        "invite_contact_name": "Inviter {name}",
        "more_actions": "Plus d'actions",
        "more_actions_for": "Plus d'actions pour {name}",
        "clear_search": "Effacer la recherche",
        "search_by_currently": "Rechercher par, actuellement {value}",
        "search_contacts": "Rechercher des contacts",
        "clear_selection": "Effacer la sélection",
        "loading": "Chargement...",
        "favorite": "Favori",
        "clear_selected_contact": "Retirer le contact sélectionné",
        "cancel_editing_contact": "Annuler la modification du contact",
        "cancel_adding_contact": "Annuler l'ajout du contact",
        "copy_label": "Copier {label}",
        "remove_file": "Retirer le fichier",
        "import_complete_summary": "Importation terminée. {imported} importés, {failed} en échec sur {total}.",
        "no_contacts_found": "Aucun contact trouvé",
        "n_in_favorites": "{n} dans les favoris",
        "no_favorites_found": "Aucun contact favori trouvé",
        "one_contact_search_cleared": "Recherche effacée, {n} contact affiché",
        "contacts_search_cleared": "Recherche effacée, {n} contacts affichés",
        "one_favorite_search_cleared": "Recherche effacée, {n} contact favori affiché",
        "favorites_search_cleared": "Recherche effacée, {n} contacts favoris affichés",
        "one_contact_found": "{n} contact trouvé",
        "contacts_found": "{n} contacts trouvés",
        "one_favorite_found": "{n} contact favori trouvé",
        "favorites_found": "{n} contacts favoris trouvés",
        "rows_not_imported_region": "Lignes non importées : {n}",
        "save_as_new_contact_available": "Enregistrer comme nouveau contact disponible",
    },
    "pt_BR": {
        "skip_to_main_content": "Ir para o conteúdo principal",
        "close": "Fechar",
        "close_search": "Fechar pesquisa",
        "sort_by_currently": "Ordenar por, atualmente {value}",
        "filter_sessions_currently": "Filtrar sessões, atualmente {value}",
        "filter_by_user_currently": "Filtrar por usuário, atualmente {value}",
        "assignee_currently": "Atribuído, atualmente {value}",
        "host_currently": "Anfitrião, atualmente {value}",
        "selected": "selecionado",
        "click_to_open_more_information": "Clique para abrir mais informações",
        "whats_new_panel_open": "O painel de novidades está aberto. Pressione Esc para fechá-lo.",
        "whats_new_unread_one": "1 notificação não lida",
        "whats_new_unread_other": "{value} notificações não lidas",
        "open_date_picker": "Abrir seletor de data",
        "open_time_picker": "Abrir seletor de hora",
        "previous_month": "Mês anterior",
        "next_month": "Próximo mês",
        "previous_year": "Ano anterior",
        "next_year": "Próximo ano",
        "previous_years": "10 anos anteriores",
        "next_years": "Próximos 10 anos",
        "hours_label": "Horas",
        "minutes_label": "Minutos",
        "am_pm_label": "AM/PM",
        "start_date_label": "Data de início",
        "start_time_label": "Hora de início",
        "end_date_label": "Data de término",
        "end_time_label": "Hora de término",
        "more_session_options": "Mais opções de sessão",
        "more_joining_options": "Mais opções para participar",
        "select_images": "Selecionar imagens",
        "country_currently": "País, atualmente {value}",
        "state_currently": "Estado, atualmente {value}",
        "search_countries": "Pesquisar países",
        "search_states": "Pesquisar estados",
        "pagination": "Paginação",
        "first_page": "Primeira página",
        "previous_page": "Página anterior",
        "next_page": "Próxima página",
        "last_page": "Última página",
        "go_to_page": "Ir para a página {n}",
        "page_current": "Página {n}, página atual",
        "rows_per_page_currently": "Linhas por página, atualmente {n}",
        "sorted_ascending": "Ordenado por {column}, crescente",
        "sorted_descending": "Ordenado por {column}, decrescente",
        "show_row_details": "Mostrar detalhes",
        "row_details": "Detalhes",
        "hide_row_details": "Ocultar detalhes",
        "results_found": "{n} resultados encontrados",
        "results_found_at_least": "Pelo menos {n} resultados encontrados",
        "no_results_found": "Nenhum resultado encontrado",
        "one_result_found": "1 resultado encontrado",
        "no_sessions_found": "Nenhuma sessão encontrada",
        "more_results_loaded": "Mais {n} resultados carregados",
        "search_cleared": "Pesquisa limpa",
        "select_contact_name": "Selecionar {name}",
        "select_contact": "Selecionar contato",
        "select_all_favorites_page": "Selecionar todos os favoritos desta página",
        "select_all_contacts_page": "Selecionar todos os contatos desta página",
        "invite_contact_name": "Convidar {name}",
        "more_actions": "Mais ações",
        "more_actions_for": "Mais ações para {name}",
        "clear_search": "Limpar pesquisa",
        "search_by_currently": "Pesquisar por, atualmente {value}",
        "search_contacts": "Pesquisar contatos",
        "clear_selection": "Limpar seleção",
        "loading": "Carregando...",
        "favorite": "Favorito",
        "clear_selected_contact": "Remover contato selecionado",
        "cancel_editing_contact": "Cancelar edição do contato",
        "cancel_adding_contact": "Cancelar adição do contato",
        "copy_label": "Copiar {label}",
        "remove_file": "Remover arquivo",
        "import_complete_summary": "Importação concluída. {imported} importados, {failed} com falha de {total}.",
        "no_contacts_found": "Nenhum contato encontrado",
        "n_in_favorites": "{n} nos favoritos",
        "no_favorites_found": "Nenhum contato favorito encontrado",
        "one_contact_search_cleared": "Pesquisa limpa, mostrando {n} contato",
        "contacts_search_cleared": "Pesquisa limpa, mostrando {n} contatos",
        "one_favorite_search_cleared": "Pesquisa limpa, mostrando {n} contato favorito",
        "favorites_search_cleared": "Pesquisa limpa, mostrando {n} contatos favoritos",
        "one_contact_found": "{n} contato encontrado",
        "contacts_found": "{n} contatos encontrados",
        "one_favorite_found": "{n} contato favorito encontrado",
        "favorites_found": "{n} contatos favoritos encontrados",
        "rows_not_imported_region": "Linhas que não puderam ser importadas: {n}",
        "save_as_new_contact_available": "Salvar como novo contato disponível",
    },
    "pt_PT": {
        "skip_to_main_content": "Saltar para o conteúdo principal",
        "close": "Fechar",
        "close_search": "Fechar pesquisa",
        "sort_by_currently": "Ordenar por, atualmente {value}",
        "filter_sessions_currently": "Filtrar sessões, atualmente {value}",
        "filter_by_user_currently": "Filtrar por utilizador, atualmente {value}",
        "assignee_currently": "Atribuído, atualmente {value}",
        "host_currently": "Anfitrião, atualmente {value}",
        "selected": "selecionado",
        "click_to_open_more_information": "Clique para abrir mais informações",
        "whats_new_panel_open": "O painel de novidades está aberto. Pressione Esc para fechá-lo.",
        "whats_new_unread_one": "1 notificação não lida",
        "whats_new_unread_other": "{value} notificações não lidas",
        "open_date_picker": "Abrir seletor de data",
        "open_time_picker": "Abrir seletor de hora",
        "previous_month": "Mês anterior",
        "next_month": "Próximo mês",
        "previous_year": "Ano anterior",
        "next_year": "Próximo ano",
        "previous_years": "10 anos anteriores",
        "next_years": "Próximos 10 anos",
        "hours_label": "Horas",
        "minutes_label": "Minutos",
        "am_pm_label": "AM/PM",
        "start_date_label": "Data de início",
        "start_time_label": "Hora de início",
        "end_date_label": "Data de término",
        "end_time_label": "Hora de término",
        "more_session_options": "Mais opções de sessão",
        "more_joining_options": "Mais opções para participar",
        "select_images": "Selecionar imagens",
        "country_currently": "País, atualmente {value}",
        "state_currently": "Estado, atualmente {value}",
        "search_countries": "Pesquisar países",
        "search_states": "Pesquisar estados",
        "pagination": "Paginação",
        "first_page": "Primeira página",
        "previous_page": "Página anterior",
        "next_page": "Página seguinte",
        "last_page": "Última página",
        "go_to_page": "Ir para a página {n}",
        "page_current": "Página {n}, página atual",
        "rows_per_page_currently": "Linhas por página, atualmente {n}",
        "sorted_ascending": "Ordenado por {column}, crescente",
        "sorted_descending": "Ordenado por {column}, decrescente",
        "show_row_details": "Mostrar detalhes",
        "row_details": "Detalhes",
        "hide_row_details": "Ocultar detalhes",
        "results_found": "{n} resultados encontrados",
        "results_found_at_least": "Pelo menos {n} resultados encontrados",
        "no_results_found": "Nenhum resultado encontrado",
        "one_result_found": "1 resultado encontrado",
        "no_sessions_found": "Nenhuma sessão encontrada",
        "more_results_loaded": "Mais {n} resultados carregados",
        "search_cleared": "Pesquisa limpa",
        "select_contact_name": "Selecionar {name}",
        "select_contact": "Selecionar contacto",
        "select_all_favorites_page": "Selecionar todos os favoritos desta página",
        "select_all_contacts_page": "Selecionar todos os contactos desta página",
        "invite_contact_name": "Convidar {name}",
        "more_actions": "Mais ações",
        "more_actions_for": "Mais ações para {name}",
        "clear_search": "Limpar pesquisa",
        "search_by_currently": "Pesquisar por, atualmente {value}",
        "search_contacts": "Pesquisar contactos",
        "clear_selection": "Limpar seleção",
        "loading": "A carregar...",
        "favorite": "Favorito",
        "clear_selected_contact": "Remover contacto selecionado",
        "cancel_editing_contact": "Cancelar edição do contacto",
        "cancel_adding_contact": "Cancelar adição do contacto",
        "copy_label": "Copiar {label}",
        "remove_file": "Remover ficheiro",
        "import_complete_summary": "Importação concluída. {imported} importados, {failed} com falha de {total}.",
        "no_contacts_found": "Nenhum contacto encontrado",
        "n_in_favorites": "{n} nos favoritos",
        "no_favorites_found": "Nenhum contacto favorito encontrado",
        "one_contact_search_cleared": "Pesquisa limpa, a mostrar {n} contacto",
        "contacts_search_cleared": "Pesquisa limpa, a mostrar {n} contactos",
        "one_favorite_search_cleared": "Pesquisa limpa, a mostrar {n} contacto favorito",
        "favorites_search_cleared": "Pesquisa limpa, a mostrar {n} contactos favoritos",
        "one_contact_found": "{n} contacto encontrado",
        "contacts_found": "{n} contactos encontrados",
        "one_favorite_found": "{n} contacto favorito encontrado",
        "favorites_found": "{n} contactos favoritos encontrados",
        "rows_not_imported_region": "Linhas que não foi possível importar: {n}",
        "save_as_new_contact_available": "Guardar como novo contacto disponível",
    },
    "it_IT": {
        "skip_to_main_content": "Vai al contenuto principale",
        "close": "Chiudi",
        "close_search": "Chiudi ricerca",
        "sort_by_currently": "Ordina per, attualmente {value}",
        "filter_sessions_currently": "Filtra sessioni, attualmente {value}",
        "filter_by_user_currently": "Filtra per utente, attualmente {value}",
        "assignee_currently": "Assegnato, attualmente {value}",
        "host_currently": "Host, attualmente {value}",
        "selected": "selezionato",
        "click_to_open_more_information": "Clicca per aprire maggiori informazioni",
        "whats_new_panel_open": "Il pannello delle novità è aperto. Premi Esc per chiuderlo.",
        "whats_new_unread_one": "1 notifica non letta",
        "whats_new_unread_other": "{value} notifiche non lette",
        "open_date_picker": "Apri selettore data",
        "open_time_picker": "Apri selettore ora",
        "previous_month": "Mese precedente",
        "next_month": "Mese successivo",
        "previous_year": "Anno precedente",
        "next_year": "Anno successivo",
        "previous_years": "10 anni precedenti",
        "next_years": "10 anni successivi",
        "hours_label": "Ore",
        "minutes_label": "Minuti",
        "am_pm_label": "AM/PM",
        "start_date_label": "Data di inizio",
        "start_time_label": "Ora di inizio",
        "end_date_label": "Data di fine",
        "end_time_label": "Ora di fine",
        "more_session_options": "Altre opzioni della sessione",
        "more_joining_options": "Altre opzioni di partecipazione",
        "select_images": "Seleziona immagini",
        "country_currently": "Paese, attualmente {value}",
        "state_currently": "Stato, attualmente {value}",
        "search_countries": "Cerca paesi",
        "search_states": "Cerca stati",
        "pagination": "Impaginazione",
        "first_page": "Prima pagina",
        "previous_page": "Pagina precedente",
        "next_page": "Pagina successiva",
        "last_page": "Ultima pagina",
        "go_to_page": "Vai alla pagina {n}",
        "page_current": "Pagina {n}, pagina corrente",
        "rows_per_page_currently": "Righe per pagina, attualmente {n}",
        "sorted_ascending": "Ordinato per {column}, crescente",
        "sorted_descending": "Ordinato per {column}, decrescente",
        "show_row_details": "Mostra dettagli",
        "row_details": "Dettagli",
        "hide_row_details": "Nascondi dettagli",
        "results_found": "{n} risultati trovati",
        "results_found_at_least": "Almeno {n} risultati trovati",
        "no_results_found": "Nessun risultato trovato",
        "one_result_found": "1 risultato trovato",
        "no_sessions_found": "Nessuna sessione trovata",
        "more_results_loaded": "Altri {n} risultati caricati",
        "search_cleared": "Ricerca cancellata",
        "select_contact_name": "Seleziona {name}",
        "select_contact": "Seleziona contatto",
        "select_all_favorites_page": "Seleziona tutti i preferiti in questa pagina",
        "select_all_contacts_page": "Seleziona tutti i contatti in questa pagina",
        "invite_contact_name": "Invita {name}",
        "more_actions": "Altre azioni",
        "more_actions_for": "Altre azioni per {name}",
        "clear_search": "Cancella ricerca",
        "search_by_currently": "Cerca per, attualmente {value}",
        "search_contacts": "Cerca contatti",
        "clear_selection": "Cancella selezione",
        "loading": "Caricamento...",
        "favorite": "Preferito",
        "clear_selected_contact": "Rimuovi contatto selezionato",
        "cancel_editing_contact": "Annulla modifica del contatto",
        "cancel_adding_contact": "Annulla aggiunta del contatto",
        "copy_label": "Copia {label}",
        "remove_file": "Rimuovi file",
        "import_complete_summary": "Importazione completata. {imported} importati, {failed} non riusciti su {total}.",
        "no_contacts_found": "Nessun contatto trovato",
        "n_in_favorites": "{n} nei preferiti",
        "no_favorites_found": "Nessun contatto preferito trovato",
        "one_contact_search_cleared": "Ricerca cancellata, visualizzato {n} contatto",
        "contacts_search_cleared": "Ricerca cancellata, visualizzati {n} contatti",
        "one_favorite_search_cleared": "Ricerca cancellata, visualizzato {n} contatto preferito",
        "favorites_search_cleared": "Ricerca cancellata, visualizzati {n} contatti preferiti",
        "one_contact_found": "{n} contatto trovato",
        "contacts_found": "{n} contatti trovati",
        "one_favorite_found": "{n} contatto preferito trovato",
        "favorites_found": "{n} contatti preferiti trovati",
        "rows_not_imported_region": "Righe non importate: {n}",
        "save_as_new_contact_available": "Salva come nuovo contatto disponibile",
    },
    "zh_CN": {
        "skip_to_main_content": "跳到主要内容",
        "close": "关闭",
        "close_search": "关闭搜索",
        "sort_by_currently": "排序方式，当前为 {value}",
        "filter_sessions_currently": "筛选会话，当前为 {value}",
        "filter_by_user_currently": "按用户筛选，当前为 {value}",
        "assignee_currently": "分配给，当前为 {value}",
        "host_currently": "主持人，当前为 {value}",
        "selected": "已选择",
        "click_to_open_more_information": "点击打开更多信息",
        "whats_new_panel_open": "新功能面板已打开。按 Esc 键关闭。",
        "whats_new_unread_one": "1 条未读通知",
        "whats_new_unread_other": "{value} 条未读通知",
        "open_date_picker": "打开日期选择器",
        "open_time_picker": "打开时间选择器",
        "previous_month": "上个月",
        "next_month": "下个月",
        "previous_year": "上一年",
        "next_year": "下一年",
        "previous_years": "前10年",
        "next_years": "后10年",
        "hours_label": "小时",
        "minutes_label": "分钟",
        "am_pm_label": "上午/下午",
        "start_date_label": "开始日期",
        "start_time_label": "开始时间",
        "end_date_label": "结束日期",
        "end_time_label": "结束时间",
        "more_session_options": "更多会话选项",
        "more_joining_options": "更多加入选项",
        "select_images": "选择图片",
        "country_currently": "国家/地区，当前为 {value}",
        "state_currently": "州/省，当前为 {value}",
        "search_countries": "搜索国家/地区",
        "search_states": "搜索州/省",
        "pagination": "分页",
        "first_page": "第一页",
        "previous_page": "上一页",
        "next_page": "下一页",
        "last_page": "最后一页",
        "go_to_page": "跳转到第 {n} 页",
        "page_current": "第 {n} 页，当前页",
        "rows_per_page_currently": "每页行数，当前为 {n}",
        "sorted_ascending": "按 {column} 升序排序",
        "sorted_descending": "按 {column} 降序排序",
        "show_row_details": "显示详细信息",
        "row_details": "详细信息",
        "hide_row_details": "隐藏详细信息",
        "results_found": "找到 {n} 个结果",
        "results_found_at_least": "至少找到 {n} 个结果",
        "no_results_found": "未找到结果",
        "one_result_found": "找到 1 个结果",
        "no_sessions_found": "未找到会话",
        "more_results_loaded": "已加载另外 {n} 个结果",
        "search_cleared": "已清除搜索",
        "select_contact_name": "选择 {name}",
        "select_contact": "选择联系人",
        "select_all_favorites_page": "选择此页上的所有收藏",
        "select_all_contacts_page": "选择此页上的所有联系人",
        "invite_contact_name": "邀请 {name}",
        "more_actions": "更多操作",
        "more_actions_for": "{name} 的更多操作",
        "clear_search": "清除搜索",
        "search_by_currently": "搜索依据，当前为 {value}",
        "search_contacts": "搜索联系人",
        "clear_selection": "清除选择",
        "loading": "正在加载...",
        "favorite": "收藏",
        "clear_selected_contact": "清除所选联系人",
        "cancel_editing_contact": "取消编辑联系人",
        "cancel_adding_contact": "取消添加联系人",
        "copy_label": "复制{label}",
        "remove_file": "移除文件",
        "import_complete_summary": "导入完成。共 {total} 条，已导入 {imported} 条，失败 {failed} 条。",
        "no_contacts_found": "未找到联系人",
        "n_in_favorites": "其中 {n} 个在收藏中",
        "no_favorites_found": "未找到收藏的联系人",
        "one_contact_search_cleared": "已清除搜索，显示 {n} 个联系人",
        "contacts_search_cleared": "已清除搜索，显示 {n} 个联系人",
        "one_favorite_search_cleared": "已清除搜索，显示 {n} 个收藏的联系人",
        "favorites_search_cleared": "已清除搜索，显示 {n} 个收藏的联系人",
        "one_contact_found": "找到 {n} 个联系人",
        "contacts_found": "找到 {n} 个联系人",
        "one_favorite_found": "找到 {n} 个收藏的联系人",
        "favorites_found": "找到 {n} 个收藏的联系人",
        "rows_not_imported_region": "无法导入的行：{n}",
        "save_as_new_contact_available": "可以保存为新联系人",
    },
    "ja_JP": {
        "skip_to_main_content": "メインコンテンツにスキップ",
        "close": "閉じる",
        "close_search": "検索を閉じる",
        "sort_by_currently": "並べ替え、現在 {value}",
        "filter_sessions_currently": "セッションのフィルター、現在 {value}",
        "filter_by_user_currently": "ユーザーで絞り込む、現在 {value}",
        "assignee_currently": "担当者、現在 {value}",
        "host_currently": "ホスト、現在 {value}",
        "selected": "選択済み",
        "click_to_open_more_information": "クリックして詳細情報を開く",
        "whats_new_panel_open": "新機能パネルが開いています。Escキーで閉じます。",
        "whats_new_unread_one": "未読の通知 1 件",
        "whats_new_unread_other": "未読の通知 {value} 件",
        "open_date_picker": "日付ピッカーを開く",
        "open_time_picker": "時間ピッカーを開く",
        "previous_month": "前の月",
        "next_month": "次の月",
        "previous_year": "前の年",
        "next_year": "次の年",
        "previous_years": "前の10年",
        "next_years": "次の10年",
        "hours_label": "時",
        "minutes_label": "分",
        "am_pm_label": "午前/午後",
        "start_date_label": "開始日",
        "start_time_label": "開始時刻",
        "end_date_label": "終了日",
        "end_time_label": "終了時刻",
        "more_session_options": "その他のセッションオプション",
        "more_joining_options": "その他の参加オプション",
        "select_images": "画像を選択",
        "country_currently": "国、現在 {value}",
        "state_currently": "州、現在 {value}",
        "search_countries": "国を検索",
        "search_states": "州を検索",
        "pagination": "ページネーション",
        "first_page": "最初のページ",
        "previous_page": "前のページ",
        "next_page": "次のページ",
        "last_page": "最後のページ",
        "go_to_page": "{n} ページ目に移動",
        "page_current": "{n} ページ目、現在のページ",
        "rows_per_page_currently": "ページあたりの行数、現在 {n}",
        "sorted_ascending": "{column} で昇順に並べ替え",
        "sorted_descending": "{column} で降順に並べ替え",
        "show_row_details": "詳細を表示",
        "row_details": "詳細",
        "hide_row_details": "詳細を非表示",
        "results_found": "{n} 件の結果が見つかりました",
        "results_found_at_least": "{n} 件以上の結果が見つかりました",
        "no_results_found": "結果が見つかりません",
        "one_result_found": "1 件の結果が見つかりました",
        "no_sessions_found": "セッションが見つかりません",
        "more_results_loaded": "さらに {n} 件の結果を読み込みました",
        "search_cleared": "検索をクリアしました",
        "select_contact_name": "{name} を選択",
        "select_contact": "連絡先を選択",
        "select_all_favorites_page": "このページのお気に入りをすべて選択",
        "select_all_contacts_page": "このページの連絡先をすべて選択",
        "invite_contact_name": "{name} を招待",
        "more_actions": "その他の操作",
        "more_actions_for": "{name} のその他の操作",
        "clear_search": "検索をクリア",
        "search_by_currently": "検索対象、現在は {value}",
        "search_contacts": "連絡先を検索",
        "clear_selection": "選択を解除",
        "loading": "読み込み中...",
        "favorite": "お気に入り",
        "clear_selected_contact": "選択した連絡先をクリア",
        "cancel_editing_contact": "連絡先の編集をキャンセル",
        "cancel_adding_contact": "連絡先の追加をキャンセル",
        "copy_label": "{label}をコピー",
        "remove_file": "ファイルを削除",
        "import_complete_summary": "インポートが完了しました。{total} 件中 {imported} 件をインポート、{failed} 件が失敗しました。",
        "no_contacts_found": "連絡先が見つかりません",
        "n_in_favorites": "お気に入りに {n} 件",
        "no_favorites_found": "お気に入りの連絡先が見つかりません",
        "one_contact_search_cleared": "検索をクリアしました。{n} 件の連絡先を表示しています",
        "contacts_search_cleared": "検索をクリアしました。{n} 件の連絡先を表示しています",
        "one_favorite_search_cleared": "検索をクリアしました。{n} 件のお気に入りの連絡先を表示しています",
        "favorites_search_cleared": "検索をクリアしました。{n} 件のお気に入りの連絡先を表示しています",
        "one_contact_found": "{n} 件の連絡先が見つかりました",
        "contacts_found": "{n} 件の連絡先が見つかりました",
        "one_favorite_found": "{n} 件のお気に入りの連絡先が見つかりました",
        "favorites_found": "{n} 件のお気に入りの連絡先が見つかりました",
        "rows_not_imported_region": "インポートできなかった行: {n}",
        "save_as_new_contact_available": "新しい連絡先として保存できます",
    },
    "pl_PL": {
        "skip_to_main_content": "Przejdź do treści głównej",
        "close": "Zamknij",
        "close_search": "Zamknij wyszukiwanie",
        "sort_by_currently": "Sortuj według, obecnie {value}",
        "filter_sessions_currently": "Filtruj sesje, obecnie {value}",
        "filter_by_user_currently": "Filtruj według użytkownika, obecnie {value}",
        "assignee_currently": "Przypisany, obecnie {value}",
        "host_currently": "Host, obecnie {value}",
        "selected": "wybrany",
        "click_to_open_more_information": "Kliknij, aby otworzyć więcej informacji",
        "whats_new_panel_open": "Panel nowości jest otwarty. Naciśnij Escape, aby go zamknąć.",
        "whats_new_unread_one": "1 nieprzeczytane powiadomienie",
        "whats_new_unread_other": "Nieprzeczytane powiadomienia: {value}",
        "open_date_picker": "Otwórz wybierak daty",
        "open_time_picker": "Otwórz wybierak czasu",
        "previous_month": "Poprzedni miesiąc",
        "next_month": "Następny miesiąc",
        "previous_year": "Poprzedni rok",
        "next_year": "Następny rok",
        "previous_years": "Poprzednie 10 lat",
        "next_years": "Następne 10 lat",
        "hours_label": "Godziny",
        "minutes_label": "Minuty",
        "am_pm_label": "AM/PM",
        "start_date_label": "Data rozpoczęcia",
        "start_time_label": "Godzina rozpoczęcia",
        "end_date_label": "Data zakończenia",
        "end_time_label": "Godzina zakończenia",
        "more_session_options": "Więcej opcji sesji",
        "more_joining_options": "Więcej opcji dołączenia",
        "select_images": "Wybierz obrazy",
        "country_currently": "Kraj, obecnie {value}",
        "state_currently": "Region, obecnie {value}",
        "search_countries": "Szukaj krajów",
        "search_states": "Szukaj regionów",
        "pagination": "Paginacja",
        "first_page": "Pierwsza strona",
        "previous_page": "Poprzednia strona",
        "next_page": "Następna strona",
        "last_page": "Ostatnia strona",
        "go_to_page": "Przejdź do strony {n}",
        "page_current": "Strona {n}, bieżąca strona",
        "rows_per_page_currently": "Wierszy na stronę, obecnie {n}",
        "sorted_ascending": "Posortowano według {column}, rosnąco",
        "sorted_descending": "Posortowano według {column}, malejąco",
        "show_row_details": "Pokaż szczegóły",
        "row_details": "Szczegóły",
        "hide_row_details": "Ukryj szczegóły",
        "results_found": "Znaleziono wyniki: {n}",
        "results_found_at_least": "Znaleziono co najmniej {n} wyników",
        "no_results_found": "Nie znaleziono wyników",
        "one_result_found": "Znaleziono 1 wynik",
        "no_sessions_found": "Nie znaleziono sesji",
        "more_results_loaded": "Załadowano {n} kolejnych wyników",
        "search_cleared": "Wyszukiwanie wyczyszczone",
        "select_contact_name": "Zaznacz {name}",
        "select_contact": "Zaznacz kontakt",
        "select_all_favorites_page": "Zaznacz wszystkie ulubione na tej stronie",
        "select_all_contacts_page": "Zaznacz wszystkie kontakty na tej stronie",
        "invite_contact_name": "Zaproś {name}",
        "more_actions": "Więcej akcji",
        "more_actions_for": "Więcej akcji dla {name}",
        "clear_search": "Wyczyść wyszukiwanie",
        "search_by_currently": "Szukaj według, obecnie {value}",
        "search_contacts": "Wyszukaj kontakty",
        "clear_selection": "Wyczyść zaznaczenie",
        "loading": "Ładowanie...",
        "favorite": "Ulubiony",
        "clear_selected_contact": "Wyczyść wybrany kontakt",
        "cancel_editing_contact": "Anuluj edycję kontaktu",
        "cancel_adding_contact": "Anuluj dodawanie kontaktu",
        "copy_label": "Kopiuj: {label}",
        "remove_file": "Usuń plik",
        "import_complete_summary": "Import zakończony. Zaimportowano: {imported}, niepowodzenia: {failed}, łącznie: {total}.",
        "no_contacts_found": "Nie znaleziono kontaktów",
        "n_in_favorites": "w ulubionych: {n}",
        "no_favorites_found": "Nie znaleziono ulubionych kontaktów",
        "one_contact_search_cleared": "Wyczyszczono wyszukiwanie, wyświetlane kontakty: {n}",
        "contacts_search_cleared": "Wyczyszczono wyszukiwanie, wyświetlane kontakty: {n}",
        "one_favorite_search_cleared": "Wyczyszczono wyszukiwanie, wyświetlane ulubione kontakty: {n}",
        "favorites_search_cleared": "Wyczyszczono wyszukiwanie, wyświetlane ulubione kontakty: {n}",
        "one_contact_found": "Znalezione kontakty: {n}",
        "contacts_found": "Znalezione kontakty: {n}",
        "one_favorite_found": "Znalezione ulubione kontakty: {n}",
        "favorites_found": "Znalezione ulubione kontakty: {n}",
        "rows_not_imported_region": "Wiersze, których nie udało się zaimportować: {n}",
        "save_as_new_contact_available": "Dostępna opcja: Zapisz jako nowy kontakt",
    },
    "ko_KR": {
        "skip_to_main_content": "본문으로 건너뛰기",
        "close": "닫기",
        "close_search": "검색 닫기",
        "sort_by_currently": "정렬 기준, 현재 {value}",
        "filter_sessions_currently": "세션 필터, 현재 {value}",
        "filter_by_user_currently": "사용자별 필터, 현재 {value}",
        "assignee_currently": "담당자, 현재 {value}",
        "host_currently": "호스트, 현재 {value}",
        "selected": "선택됨",
        "click_to_open_more_information": "클릭하여 추가 정보 열기",
        "whats_new_panel_open": "새로운 기능 패널이 열려 있습니다. Esc 키를 눌러 닫으세요.",
        "whats_new_unread_one": "읽지 않은 알림 1개",
        "whats_new_unread_other": "읽지 않은 알림 {value}개",
        "open_date_picker": "날짜 선택기 열기",
        "open_time_picker": "시간 선택기 열기",
        "previous_month": "이전 달",
        "next_month": "다음 달",
        "previous_year": "이전 연도",
        "next_year": "다음 연도",
        "previous_years": "이전 10년",
        "next_years": "다음 10년",
        "hours_label": "시",
        "minutes_label": "분",
        "am_pm_label": "오전/오후",
        "start_date_label": "시작 날짜",
        "start_time_label": "시작 시간",
        "end_date_label": "종료 날짜",
        "end_time_label": "종료 시간",
        "more_session_options": "세션 옵션 더보기",
        "more_joining_options": "참여 옵션 더보기",
        "select_images": "이미지 선택",
        "country_currently": "국가, 현재 {value}",
        "state_currently": "지역, 현재 {value}",
        "search_countries": "국가 검색",
        "search_states": "지역 검색",
        "pagination": "페이지 매김",
        "first_page": "첫 페이지",
        "previous_page": "이전 페이지",
        "next_page": "다음 페이지",
        "last_page": "마지막 페이지",
        "go_to_page": "{n} 페이지로 이동",
        "page_current": "{n} 페이지, 현재 페이지",
        "rows_per_page_currently": "페이지당 행 수, 현재 {n}",
        "sorted_ascending": "{column} 기준 오름차순 정렬",
        "sorted_descending": "{column} 기준 내림차순 정렬",
        "show_row_details": "세부 정보 표시",
        "row_details": "세부 정보",
        "hide_row_details": "세부 정보 숨기기",
        "results_found": "{n}개의 결과를 찾았습니다",
        "results_found_at_least": "최소 {n}개의 결과를 찾았습니다",
        "no_results_found": "결과를 찾을 수 없습니다",
        "one_result_found": "1개의 결과를 찾았습니다",
        "no_sessions_found": "세션을 찾을 수 없습니다",
        "more_results_loaded": "{n}개의 결과를 더 불러왔습니다",
        "search_cleared": "검색이 지워졌습니다",
        "select_contact_name": "{name} 선택",
        "select_contact": "연락처 선택",
        "select_all_favorites_page": "이 페이지의 즐겨찾기 모두 선택",
        "select_all_contacts_page": "이 페이지의 연락처 모두 선택",
        "invite_contact_name": "{name} 초대",
        "more_actions": "추가 작업",
        "more_actions_for": "{name}에 대한 추가 작업",
        "clear_search": "검색 지우기",
        "search_by_currently": "검색 기준, 현재 {value}",
        "search_contacts": "연락처 검색",
        "clear_selection": "선택 해제",
        "loading": "불러오는 중...",
        "favorite": "즐겨찾기",
        "clear_selected_contact": "선택한 연락처 지우기",
        "cancel_editing_contact": "연락처 편집 취소",
        "cancel_adding_contact": "연락처 추가 취소",
        "copy_label": "{label} 복사",
        "remove_file": "파일 제거",
        "import_complete_summary": "가져오기가 완료되었습니다. 전체 {total}개 중 {imported}개 가져옴, {failed}개 실패.",
        "no_contacts_found": "연락처를 찾을 수 없습니다",
        "n_in_favorites": "즐겨찾기에 {n}개",
        "no_favorites_found": "즐겨찾기 연락처를 찾을 수 없습니다",
        "one_contact_search_cleared": "검색이 지워졌습니다. 연락처 {n}개 표시 중",
        "contacts_search_cleared": "검색이 지워졌습니다. 연락처 {n}개 표시 중",
        "one_favorite_search_cleared": "검색이 지워졌습니다. 즐겨찾기 연락처 {n}개 표시 중",
        "favorites_search_cleared": "검색이 지워졌습니다. 즐겨찾기 연락처 {n}개 표시 중",
        "one_contact_found": "연락처 {n}개를 찾았습니다",
        "contacts_found": "연락처 {n}개를 찾았습니다",
        "one_favorite_found": "즐겨찾기 연락처 {n}개를 찾았습니다",
        "favorites_found": "즐겨찾기 연락처 {n}개를 찾았습니다",
        "rows_not_imported_region": "가져올 수 없는 행: {n}",
        "save_as_new_contact_available": "새 연락처로 저장할 수 있습니다",
    },
};
